<div id="login-page">
  <app-minimalist-entry>
    <a slot="link" [routerLink]="['/register']">
      <span
        style="margin-left: 10px; cursor: pointer; text-decoration: underline"
        i18n="register link option|The register label of the link that redirects to the register screen@@registerRedirectLinkLabel"
      >Signup</span>
    </a>
    <a slot="link" class="selected" [routerLink]="['/login']">
      <span
        style="margin-left: 10px; color: #73809C; cursor: default;"
        i18n="login link option|The login label of the link that redirects to the login screen@@loginRedirectLinkLabel"
      >Login</span>
    </a>
    <div slot="content">
      <form class="form-login" [formGroup]="form" (keyup.enter)="onEnterSubmit()">
        <div class="form-inner-group input-group email">
          <input
            formControlName="email"
            type="email"
            class="form-control"
            i18n-placeholder="email address placeholder|The placeholder that is visible at an email address input before a content is written to it@@emailAddressPlaceholder"
            placeholder="Email"
            autocomplete="email"
            spellcheck="false"
            autofocus
            required
            [readonly]="this.loading"
          >
        </div>
        <div class="form-inner-group input-group password">
          <input
            formControlName="password"
            type="password"
            class="form-control"
            i18n-placeholder="password placeholder|The placeholder that is visible at an password input before a content is written to it@@passwordPlaceholder"
            placeholder="Password"
            required
            [readonly]="this.loading"
          >
        </div>
        <div class="form-inner-group alert-wrapper" *ngIf="(attemptedSubmit && form.invalid && form.dirty) || errorMessage">
          <div *ngIf="form.invalid && form.dirty">
            <ul class="alert alert-danger">
              <li
                *ngIf="email.invalid && email.dirty"
                i18n="email is required|Error message for when the email is missing or invalid@@emailRequired"
              >Email is required</li>
              <li
                *ngIf="password.invalid && password.dirty"
                i18n="password is required|Error message for when the password is missing or invalid@@passwordRequired"
              >Password is required</li>
            </ul>
          </div>
          <div *ngIf="errorMessage">
            <div class="alert alert-danger">{{ errorMessage }}</div>
          </div>
          <div *ngIf="errorMessage =='User is not active'">
            <div class="btn btn-link" i18n="resend Activation@@resendActivation" (click)="resend()">Please, send me activation e-mail again</div>
          </div>
        </div>
        <div class="form-inner-group actions">
          <button type="submit" class="btn btn-theme btn-block btn-with-left-icon" (click)="onLoginClick()">
            <i *ngIf="!loading" class="fa fa-lock"></i>
            <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin"></i>
            <span
              i18n="Login button label|The text on the button used to authenticate@@loginButtonLabel"
            >Login</span>
          </button>
        </div>
        <div class="extra-actions">
          <div class="forgot-password pull-right">
            <span
              i18n="Forgot your password prefix|The text before the link below the login screen used to contextualize the reset password link right after it@@forgotYourPasswordPrefix"
            >Forgot password?</span>
            <button
              class="btn btn-link btn-anchor btn-underlined"
              (click)="onForgotClick($event)"
              i18n="Forgot your password link text|The text in the anchor that, when clicked, allows the user to reset his password@@resetPasswordActionBeginLink"
            >Reset it</button>
          </div>
        </div>
      </form>
    </div>
  </app-minimalist-entry>
</div>
